import { render, staticRenderFns } from "./WariWariMainSymbol.vue?vue&type=template&id=604590d5&"
import script from "./WariWariMainSymbol.vue?vue&type=script&lang=js&"
export * from "./WariWariMainSymbol.vue?vue&type=script&lang=js&"
import style0 from "./WariWariMainSymbol.vue?vue&type=style&index=0&id=604590d5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports